(function(){
  window.addEventListener("load", (event) => {
    boxElement = document.querySelector("#box");
  
    createObserver();
  }, false);
  
  function createObserver() {
    // Options for the observer (which mutations to observe)
    const config = { attributes: true, childList: true, subtree: true };
    
    // Callback function to execute when mutations are observed
    const callback = function(mutationList, observer) {
        
        for(const mutation of mutationList) {
          if (mutation.target.id == 'customily-cart-btn' && (!document.getElementById('download-canvas-link'))) {
            if (document.querySelector('.customily-modal-container #customily-cart-btn')) {
              createDownloadLink();
              observer.disconnect();
            }
          }
        }
    };
    
    // Create an observer instance linked to the callback function
    const observer = new MutationObserver(callback);
    
    const targetNode = document.body;
    observer.observe(targetNode, config);
    
    function createDownloadLink() {
      var button = document.createElement('button');
      button.className = 'button button--primary';
      button.id = 'download-canvas-link';
      button.textContent = 'Download';
      button.style.borderRadius = 'var(--buttons-radius-outset)';
      
      // link.href = document.getElementById('preview-canvas').toDataURL();
      document.querySelector('.customily-modal-container #customily-cart-btn').parentNode.append(button);
      
      button.addEventListener('click', evt => {
        var link = document.createElement('a');
        link.download = 'mockup.png';
        link.href = document.getElementById('preview-canvas').toDataURL();
        link.click();
      });
    }
  }
})();

(function() {

  
  function animatedScroll() {
    var startAnimationsElements = document.querySelectorAll('.start-sections-animation--true');
    startAnimationsElements.forEach((startElement, i) => {
      let sectionsToBeAnimated = [];
      const section1 = startElement.parentNode;
      let gotLastSection = false;
      const sectionNextSibs = Array.from(getNextSiblings(section1));
      sectionsToBeAnimated.push(section1);
      
      sectionNextSibs.every(section => {
        if(section.querySelector('.end-sections-animation--true')) {
          sectionsToBeAnimated.push(section)
          gotLastSection = true;
          return false;
        }
        
        sectionsToBeAnimated.push(section)
        return true;
      });
      
      
      if (!gotLastSection) return;
      const sectionsWrapper = document.createElement('div');
      sectionsWrapper.classList.add('animated-section-true');
      sectionsToBeAnimated[0].parentNode.insertBefore(sectionsWrapper, sectionsToBeAnimated[0]);
      sectionsToBeAnimated.forEach(item => sectionsWrapper.append(item));
      
    });
  };
  animatedScroll();
  // ['shopify:block:load', 'shopify:section:load'].forEach( evt => {
  //   document.addEventListener(evt, animatedScroll)
  // });

  function getNextSiblings(elem, filter) {
    var sibs = [];
    while (elem = elem.nextSibling) {
        if (elem.nodeType === 3) continue; // text node
        if (!filter || filter(elem)) sibs.push(elem);
    }
    return sibs;
  };
  
  var sectionsToAnimate = document.querySelectorAll('.animated-section-true > *');
  window.addEventListener('scroll', (evt) => {
    sectionsToAnimate.forEach((item, i) => {
      const nextSib = item.nextElementSibling;
      if (!nextSib) return;
        onScrollHandler(item, nextSib, evt);
    });
  }, {passive: false});
  
  var speed = 80;
  // console.log('speed', speed);
  var slowingScrollFlag = false;
  const onScrollHandler = function(elem, nextSib, evt) {
    let transformRatio = 1 - nextSib.getBoundingClientRect()['y']/nextSib.scrollHeight;
    transformRatio = Math.max(transformRatio, 0);
    const transform = transformRatio * 250;
    elem.style.setProperty('--scroll-transition', `-${transform}px`);
  }

})();

(function() {
  document.querySelectorAll('.hp-fade-animation').forEach((item, i) => {
    var animatedItemClass = 'hp-fade-animation__item';
    var activeItemClass = 'hp-fade-animation__item--active';
    const sldeInterval = setInterval(() => {
      const activeImgIndex = parseInt(item.querySelector(`.${activeItemClass}`).dataset.index);
      const newActiveIndex = item.querySelector(`.${animatedItemClass}[data-index="${activeImgIndex+1}"]`) ? activeImgIndex+1 : 1;
      
      if(! item.querySelector(`.${animatedItemClass}[data-index="${activeImgIndex+1}"]`) && item.hasAttribute('data-one-loop')) return  clearInterval(sldeInterval);
      item.querySelectorAll(`.${activeItemClass}`).forEach(box => box.classList.remove(activeItemClass));
      item.querySelectorAll(`.${animatedItemClass}[data-index="${newActiveIndex}"]`).forEach(box => box.classList.add(activeItemClass));
    }, item.dataset.slideSpeed);
  });
})();

// document.addEventListener("DOMContentLoaded", function() {
  var lazyVideos = [].slice.call(document.querySelectorAll("video.lazy, .lazy-video video"));
  if ("IntersectionObserver" in window) {
    var lazyVideoObserver = new IntersectionObserver(function(entries, observer) {
      entries.forEach(function(video) {
        if (video.isIntersecting) {
          for (var source in video.target.children) {
            var videoSource = video.target.children[source];
            if (typeof videoSource.tagName === "string" && videoSource.tagName === "SOURCE") {
              videoSource.src = videoSource.dataset.src;
            }
          }

          video.target.load();
          video.target.classList.remove("lazy");
          lazyVideoObserver.unobserve(video.target);
        }
      });
    });

    lazyVideos.forEach(function(lazyVideo) {
      lazyVideoObserver.observe(lazyVideo);
    });
  }
// });

(function (){
  if (!document.querySelector('.page-list-collections')) return;
  if ('scrollRestoration' in history) {
    history.scrollRestoration = 'manual';
  }
  
  document.documentElement.style.scrollBehavior = "unset";
  window.scrollTo({
    top: 0
  });
  
  const stickyHeader = document.querySelector('sticky-header');
  if (stickyHeader) {
    stickyHeader.preventReveal = true;
  }
  
  document.documentElement.style.scrollBehavior = '';
})();
